import React, { useState, useEffect } from "react";
import Pagination from "../../../common/pagination";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { paginate } from "../../../utils/paginate";
import Table from "./../../../common/table";
import getService from "../../../services/getService";
import NoImage from "../../../assets/images/NoImage.png";
import deleteService from "../../../services/deleteService";
import { toast } from "react-toastify";
import Delete from "../../../common/delete";
import { CSVLink } from "react-csv";

const BannerTable = () => {
  const [banners, setBanners] = useState([]);
  const [id, setId] = useState(null);

  const fetchBanner = async () => {
    const data = await getService.handleBanner();
    setBanners(data);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDelete = async (id) => {
    try {
      await deleteService.DeleteHomeBanner({ id });
      setCurrentPage(1);
      fetchBanner();
    } catch (error) {
      toast.error(error);
    }
    setId(null);
  };

  const getPagedData = () => {
    const banner = paginate(banners, currentPage, pageSize);
    return { totalCount: banners.length, data: banner };
  };

  const { length: count } = banners;

  const { totalCount, data: banner } = getPagedData();

  const columns = [
    {
      key: "",
      label: "S.No",
      content: (banner) => <p>{banners.indexOf(banner) + 1}</p>,
    },
    { path: "title", label: "Title" },
    {
      path: "logo",
      label: "Logo",
      content: (c) => (
        <>
          {c.img1 !== null ? (
            <img
              style={{ width: "100px", height: "100px" }}
              src={c.img1}
              alt="Onclq.com"
            />
          ) : (
            <img
              style={{ width: "100px", height: "100px" }}
              src={NoImage}
              alt="Onclq.com"
            />
          )}
        </>
      ),
    },

    {
      key: "Action",
      label: "Action",
      content: (banner) => (
        <>
          <button
            class="btn btn-info btn-xs m-b-5 custom_btn"
            onClick={() => {
              navigate(`/admin/bannerform/${banner.id}`);
            }}
          >
            <i class="pe-7s-note" aria-hidden="true"></i>
          </button>
          <Delete
            id={id}
            ItemId={banner.id}
            setId={setId}
            onClick={handleDelete}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchBanner();
  }, []);

  if (count === 0) return <p>There are no orders in the database.</p>;

  return (
    <>
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-bd lobidrag">
            <div class="panel-heading">
              <div class="panel-title">
                <h4>Banner List </h4>
              </div>
              <CSVLink data={banners} className="btn btn-outline-success">
                Download Report
              </CSVLink>
            </div>
            <div class="panel-body">
              <Table columns={columns} data={banner} />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-5">
          <div
            class="dataTables_info"
            id="supplierList_info"
            role="status"
            aria-live="polite"
          >
            Showing {totalCount} entries in the Database
          </div>
        </div>
        <div class="col-sm-7">
          <Pagination
            itemsCount={totalCount}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default BannerTable;
